import type { FunctionComponent } from "react";
import { useMemo } from "react";

import HorizontalStats from "~/components/HorizontalStats/HorizontalStats.tsx";
import OverflowPercentageChart from "~/components/OverflowPercentageChart/OverflowPercentageChart.tsx";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";


type Props = {
	amountCents: number;
	amountLabel?: string;
	assignedCents: number;
	budgetCentsConsumed: number;
};

const QuotaBudgetStats: FunctionComponent<Props> = ({
	amountCents,
	amountLabel = "Budget",
	assignedCents,
	budgetCentsConsumed,
}) => {
	const percentageConsumed = (budgetCentsConsumed / amountCents) * 100;

	const amountFormatted = formatCentsToCurrency(amountCents);
	const assignedFormatted = formatCentsToCurrency(assignedCents);
	const consumedFormatted = formatCentsToCurrency(budgetCentsConsumed);
	const restFormatted = formatCentsToCurrency(amountCents - budgetCentsConsumed);
	const percentageConsumedFormatted = percentageConsumed === Infinity ? "n/a" : percentageConsumed.toFixed(0) + "%";

	const stats = useMemo(() => {

		return [
			{
				label: amountLabel,
				value: amountFormatted,
			},
			{
				label: "Zugewiesen",
				value: assignedFormatted,
				isDimmed: true,
			},
			{
				label: "Verfügt",
				value: consumedFormatted,
			},
			{
				label: "Rest",
				value: restFormatted,
				isHighlighted: amountCents - budgetCentsConsumed < 0,
			}];
	}, [amountCents, amountFormatted, amountLabel, assignedFormatted, budgetCentsConsumed, consumedFormatted, restFormatted]);


	return (
		<HorizontalStats stats={stats}>
			<OverflowPercentageChart percentage={percentageConsumed === Infinity ? 0 : percentageConsumed}
									 size={80}
									 thickness={0.4}>
				<div className="text-center text-sm font-bold">
					{percentageConsumedFormatted}
				</div>
			</OverflowPercentageChart>
		</HorizontalStats>
	);
};

export default QuotaBudgetStats;
